import React, { useState } from "react";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
//
import { IconButton, Typography } from "@/components";
//
import { StyledStack } from "./style";

const Feedback = (props) => {
  const { onFeedback, children, feedback } = props;

  const [loadingFeedback, setLoadingFeedback] = useState(false);

  // Se já existe feedback, mostrar apenas o ícone correspondente
  if (feedback) {
    return (
      <StyledStack>
        {feedback.toUpperCase() === "LIKE" ? (
          <ThumbUpIcon fontSize="small" sx={{ color: '#1976d2' }} />
        ) : (
          <ThumbDownIcon fontSize="small" sx={{ color: '#d32f2f' }} />
        )}
        {children && (
          <Typography variant="body1" component="div" marginLeft={1}>
            {children}
          </Typography>
        )}
      </StyledStack>
    );
  }

  const handleDislike = async () => {
    setLoadingFeedback(true);
    await onFeedback({
      type: "DISLIKE",
      timestamp: new Date().toISOString(),
    });
    setLoadingFeedback(false);
  };

  const handleLike = async () => {
    setLoadingFeedback(true);
    await onFeedback({
      type: "LIKE",
      timestamp: new Date().toISOString(),
    });
    setLoadingFeedback(false);
  };

  return (
    <>
      <StyledStack>
        <IconButton
          onClick={handleLike}
          disabled={loadingFeedback}
          aria-label="like"
          size="small"
        >
          <ThumbUpIcon fontSize="small" />
        </IconButton>
        <IconButton
          onClick={handleDislike}
          disabled={loadingFeedback}
          aria-label="dislike"
          size="small"
        >
          <ThumbDownIcon fontSize="small" />
        </IconButton>
        {children && (
          <Typography variant="body1" component="div" marginLeft={1}>
            {children}
          </Typography>
        )}
      </StyledStack>
    </>
  );
};

export default Feedback;
